<nb-card>
    <nb-card-header>
        <div class="row">
            <div class="col-12">Save a crowdsale</div>
        </div>
    </nb-card-header>
    <nb-card-body>
        <div class="row mb-3">
            <div class="col-12">
                <label class="mb-2">Contract address</label>
                <input
                    fullWidth
                    fieldSize="small"
                    nbInput
                    type="text"
                    [(ngModel)]="contractAddress"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <button
                    fullWidth
                    nbButton
                    size="small"
                    status="success"
                    (click)="onSaveCrowdsale()"
                    [disabled]="!contractAddress"
                >
                    SAVE CROWDSALE
                </button>
            </div>
        </div>
    </nb-card-body>
</nb-card>
